(function (_) {
    'use strict';

    function sizeFitIframe(iframe, size) {
        if (!iframe) {
            return;
        }
        try {
            // Add 32 to make sure the scroll is not present
            var actualHeight = size + 32;

            var tmp = iframe.parentNode;
            iframe.style.height = actualHeight + 'px';
            while (!/(^|\s)iframe-parent(\s|$)/.test(tmp.className)) {
                tmp.style.minHeight = actualHeight + 'px';
                tmp = tmp.parentNode;
            }
        } catch (e) {
            // Prematurely reading the height may cause an error
        }
    }

    _.sizeFitIframe = sizeFitIframe;

}(window.SPiD || {}));
